export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Wyszukaj adres dostawy',
      },
      placeholder: 'Wpisz adres, aby znaleźć najbliższą lokalizację',
    },
  },
  toasts: {
    failed_to_load_stores: 'Nie udało się załadować restauracji, odśwież stronę',
  },
  errors: {
    no_delivery_companies: 'Dostawa niedostępna dla tego adresu',
    delivery_not_available: 'Niestety, w tej chwili nie oferujemy dostawy',
    location_unavailable: 'Nie można uzyskać dostępu do lokalizacji, włącz uprawnienia lub wpisz adres ręcznie',
    location_lookup_failed: 'Nie można znaleźć adresu. Spróbuj ponownie',
    address_suggestions_unavailable: 'Nie udało się załadować podpowiedzi adresów.',
  },
  buttons: {
    use_current_location: 'Użyj mojej bieżącej lokalizacji',
    locating: 'Szukam Twojej lokalizacji…',
    retry: 'Spróbuj ponownie',
  },
};
